/* eslint-disable @typescript-eslint/naming-convention */
import { UserRole } from '../enums/user-role.enum';

export const APP_ROLES = {
  ALL: [
    UserRole.ClientsAll,
    UserRole.ClientsOwned
  ]
};
